//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {windVane} from '../../utils/tmallGenius';
//
export default {
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("联系客服");
    next();
  },
  /*------------------------------------------- 开始运行 -------------------------------------------------------*/

  methods: {}
};



// WEBPACK FOOTER //
// ./src/pages/ContactUs/Index.vue